import React, { useState, useEffect } from "react";
import axios from "axios";
// Below are for import the components
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const TeacherResults = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector(
    (state) => state.userDetailsData.LoginDetails
  );
  const USYear = useSelector((state) => state.SelecYearData.SYear);
 const [AssessmenTesTypes, SetAssessmenTesTypes] = useState([]);
  const [SAResults, SetSAResults] = useState();
  const [Load, SetLoad] = useState(false);

  const GetSchoolAssessmentResults = async () => {
    SetSAResults();
     if (USYear?.display === "2024-25" || USYear?.display === "2025-26") {
      SetAssessmenTesTypes([
        { title: "SODHANA", type: 1 },
        { title: "SADHANA", type: 2 },
        { title: "SAMAGRA", type: 3 }
      ]);
    } else {
      SetAssessmenTesTypes([
        { title: "SODHANA", type: 1 },
        { title: "SAMAGRA", type: 3 }
      ]);
    }
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/GetSchoolAssessmentResults?InstituteId=${items?.instituteId}&LoginId=${items?.schoolId}&Year=${USYear?.value}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].paperCode) {
          SetSAResults(res.data);
        } else {
          // SetSAResults(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const StudentWR = (Row) => {
    localStorage.removeItem("T2S");
    navigate("/TeacherDashboard/StudentInformation/Results/Studentwiseresults", {
      state: { CCID: Row.contestCreationID, AssessmentDate: Row.paperCode, TType: Row?.assessmentType, AssessmentTypeName: Row?.assessmentTypeName },
    });
  };
  // const Navigatequestionpaper = (Row) => {
  //   localStorage.setItem("QPaper", Row.contestCreationID);
  //   navigate("/TeacherDashboard/StudentInformation/Results/QuestionPaper");
  // };
  const columns = [
    { name: "Assessment Name", selector: "assessmentTypeName", sortable: true },
    { name: "Assessment Date", selector: "paperCode", sortable: true },
    { name: "No. of Questions", selector: "noOfQuestions", sortable: true },
    { name: "Duration(Mins)", selector: "testDuration", sortable: true },
    {
      name: "Results",
      cell: (row) => (
        <div className="text-primary CPointer ">
          <span onClick={() => StudentWR(row)}>Student wise</span>{" "}
        </div>
      ),
    },
  ];
  useEffect(() => {
    if (USYear?.value) {
      GetSchoolAssessmentResults();
    }
  }, [USYear]);
  // const AssessmenTesTypes = [
  //   { title: "SODHANA", type: 1 },
  //   { title: "SADHANA", type: 2 },
  //   { title: "SAMAGRA", type: 3 },
  // ];
  const renderRows = (type) => {
    const filtered = SAResults?.filter((item) => item.assessmentType === type);
    if (!filtered?.length) {
      return (
        <tr> <td colSpan={5} > ** No data available ** </td> </tr>
      );
    }

    return filtered?.map((item) => (
      <tr key={item.assessmentTypeNo}>
        <td>{item?.assessmentTypeName.split(" ")[1]}</td>
        <td>{item?.paperCode}</td>
        <td>{item?.noOfQuestions} </td>
        <td>{item?.testDuration}</td>
        <td className="text-primary CPointer" onClick={() => StudentWR(item)} >Student wise </td>
      </tr>
    ));
  };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="MainHeading">Results of Assessments</div>

        <div className="NCLDataTable">
          <table className="Data-Table" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr >
                <th>Assessment No</th>
                <th>Assessment Date</th>
                <th>No. of Questions</th>
                <th>Duration (Mins)</th>
                <th >Results</th>
              </tr>
            </thead>

          </table>
        </div>
        {AssessmenTesTypes.map(({ title, type }) => (
          <div className="Card NCLDataTable mt-2">
            <div className="SubHeading mt-1 mb-2">{title}</div>
            <table className="Data-Table" style={{ tableLayout: "fixed" }}>
              <tbody>
                {renderRows(type)}
              </tbody>
            </table>

          </div>
        ))}
        <div className="Info-Message mt-2">
          Click on <b>Student wise</b> to view students wise result.
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default TeacherResults;
